<template>
    <div class="top-header" v-if="titleData">
        <div class="top-title">
            <div>
                <img class="header-logo" src="../assets/top-logo-color.png" v-if="titleData.orgId != 13 && titleData.orgId != 54 && titleData.orgId != 55"/>
                <img class="header-logo" src="../assets/top-logo-daming.jpg" v-if="titleData.authorizationCode == 420276"/>
                <img class="header-logo" src="../assets/top-logo-hnsy.jpg" v-if="titleData.authorizationCode == 980989 || titleData.authorizationCode == 980990"/>
                <img class="header-logo" src="../assets/top-logo-hcfy.jpg" v-if="titleData.authorizationCode == 420277"/>
                <img class="header-logo" src="../assets/top-logo-baiyin.png" v-if="titleData.authorizationCode == 694771"/>
                <img class="header-logo" src="../assets/top-logo-shanxian.png" v-if="titleData.authorizationCode == 336360"/>
            </div>
            <div class="header-title">脊柱与体态筛查报告</div>
        </div>
        <div class="head-line"></div>

        <div class="header-content">
            <div>
                <div class="header-user-info">
                    <span class="header-user-info-label">姓名 </span>
                    <span class="header-user-info-value">{{ titleData.name }}</span>

                    <span class="header-user-info-label" style="margin-left: 70px;">ID </span>
                    <span class="header-user-info-value">{{ titleData.phone }}</span>
                </div>
                <div class="header-user-info">
                    <div>
                        <span class="header-user-info-label">身高</span>
                        <span class="header-user-info-value">{{ titleData.height }}</span>
                    </div>
                    <div>
                        <span class="header-user-info-label" style="margin-left: 70px;">年龄</span>
                        <span class="header-user-info-value">{{ titleData.age }}岁</span>
                    </div>
                    <div>
                        <span class="header-user-info-label" style="margin-left: 70px;">性别</span>
                        <span class="header-user-info-value">{{ titleData.gender == 'male' ? '男' : '女' }}</span>
                    </div>
                    <div>
                        <span class="header-user-info-label" style="margin-left: 70px;">检测时间</span>
                        <span class="header-user-info-value">{{ titleData.createTimeStr }}</span>
                    </div>
                </div>
            </div>
            <div>
                <div class="header-info-content">
                    <span class="item-div">需经过专业医师或康复治疗师查体诊断作为医疗依据</span>
                    <span class="item-div">*报告内容仅供参考，不作为诊断或医疗依据</span>
                </div>
            </div>
        </div>



        <div class="header-line-div"></div>
    </div>
</template>
<script>
import print from "print-js";
export default {
    props: {
        titleData: {
            type: Object,
            required: true
        }
    },
}
</script>


<style scoped>
.top-header {
    display: flex;
    width: 100%;
    height: 197px;
    flex-direction: column;
}

.top-title {
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.header-logo {
    width: 198px;
    height: 42px;
    margin: 48px 0 0 30px;
}

.header-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 33px;
    color: #333333;
    line-height: 45px;
    margin: 46px 30px 0 0;

}

.head-line {
    background: #43B99F;
    height: 4px;
    margin: 12px 30px 0 30px;
}

.header-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.header-user-info {
    display: flex;
    margin: 18px 0 0 31px;
}

.header-user-info-label {
    font-weight: 400;
    font-size: 13px;
    color: #333333;
    font-family: PingFangSC, PingFang SC;
}

.header-user-info-value {
    font-weight: 500;
    font-size: 13px;
    color: #333333;
    margin-left: 18px;
    font-family: PingFangSC, PingFang SC;
}

.header-line-div {
    display: flex;
    background: #43B99F;
    height: 1px;
    margin: 12px 30px 0 30px;
}

.header-info-content {
    display: flex;
    height: 100%;
    justify-content: center;
    margin-right: 44px;
    align-items: end;
    flex-direction: column;
}

.item-div {
    margin-top: 13px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 7px;
}
</style>